import { capitalize } from '../misc.js';

export default function (...args)
{
	return {
		setValue(value, _this = this)
		{
			if (value?.toUpperCase)
				value = value.toUpperCase();
			this.safeProtoCall(value, _this);
		}
	};
}

